import LocationLayout from './LocationLayout';
import { P, H2b, UL, LI } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-hamilton');

export default function Hamilton() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <H2b>The Steel City's fabrication heritage</H2b>
      <P>
        Hamilton has been Canada's steel town for over a century, and that history is still visible in its fabrication sector today. The city grew up around
        large-scale steel production, and the generations of tradespeople trained in and around that industry went on to staff — and eventually open — the
        welding and fabrication shops that now serve the wider region. That heritage shows up as a genuine depth of welding skill that is harder to find at
        the same scale in other parts of Ontario.
      </P>

      <H2b>Deep welding expertise</H2b>
      <P>
        Structural welding, heavy fabrication, and large-format assembly are Hamilton strengths in a way that reflects its industrial roots. Shops here are
        comfortable working with thicker material, larger assemblies, and structural applications that some fabricators elsewhere would need to subcontract
        out. If your project involves welded steel frames, structural supports, or heavy-duty equipment fabrication, Hamilton's shop base is built for
        exactly that kind of work.
      </P>

      <H2b>Lower shop rates than Toronto</H2b>
      <P>
        Hamilton's fabrication shops also tend to run at meaningfully lower overhead than comparable operations in Toronto — commercial and industrial rent
        in the city remains well below Toronto rates, and that difference shows up directly in shop pricing. Clients sourcing through Hamilton typically see
        quotes run roughly 15–25% lower than an equivalent job quoted in Toronto, without a difference in capability for the kind of heavy fabrication work
        the city specializes in.
      </P>

      <H2b>Industries served</H2b>
      <UL>
        <LI><strong>Construction and structural steel</strong> — welded frames, structural brackets, and site-built steel components.</LI>
        <LI><strong>Industrial manufacturers</strong> — heavy equipment components and custom machinery parts.</LI>
        <LI><strong>Heavy equipment operators</strong> — repair fabrication, custom attachments, and replacement structural parts.</LI>
      </UL>
      <P>
        A number of Hamilton shops are also comfortable with material specifications that would give a lighter-duty fabricator pause — thick plate steel,
        large structural sections, and assemblies that need to be moved and welded with heavy-duty equipment. If your part calls for that kind of
        capability, it is worth sourcing from Hamilton specifically rather than a general-purpose shop elsewhere in the GTA.
      </P>
      <P>
        Submit a sketch of your project and MetalMatch will match you with Hamilton-area fabricators suited to the scale and material thickness of your
        part — capturing the city's welding depth and lower shop rates without you needing to know which shop handles which kind of heavy work.
      </P>
    </LocationLayout>
  );
}
